__turbopack_context__.v({
  "badge": "Badge-module-scss-module__VyVEVa__badge",
  "icon": "Badge-module-scss-module__VyVEVa__icon",
  "iconLeft": "Badge-module-scss-module__VyVEVa__iconLeft",
  "iconRight": "Badge-module-scss-module__VyVEVa__iconRight",
  "indigoLight": "Badge-module-scss-module__VyVEVa__indigoLight",
  "red": "Badge-module-scss-module__VyVEVa__red",
  "white": "Badge-module-scss-module__VyVEVa__white",
});
